module.exports = __webpack_public_path__ + "img/tool-icon.2cd3f8e5.svg";